import { render } from "./assistant_standalone.html?vue&type=template&id=4314cc82&external"
import script from "./assistant_standalone.js?vue&type=script&lang=js&external"
export * from "./assistant_standalone.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__